import { render } from "./StudentSubmitedPaper.vue?vue&type=template&id=846a543a"
import script from "./StudentSubmitedPaper.vue?vue&type=script&lang=js"
export * from "./StudentSubmitedPaper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__